import React from 'react';
import { WrenchIcon, FileCheckIcon, ShieldAlertIcon, SearchCheckIcon } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';
import { ScrollFadeIn } from './ScrollFadeIn';
export function About() {
  const {
    t
  } = useLanguage();
  const highlights = [{
    titleKey: 'about.highlight.engineering',
    descKey: 'about.highlight.engineering.desc',
    Icon: WrenchIcon
  }, {
    titleKey: 'about.highlight.compliance',
    descKey: 'about.highlight.compliance.desc',
    Icon: FileCheckIcon
  }, {
    titleKey: 'about.highlight.safety',
    descKey: 'about.highlight.safety.desc',
    Icon: ShieldAlertIcon
  }, {
    titleKey: 'about.highlight.quality',
    descKey: 'about.highlight.quality.desc',
    Icon: SearchCheckIcon
  }];
  return <section id="about" className="w-full bg-graphite py-20 sm:py-28" data-id="element-17">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-18">
        <ScrollFadeIn data-id="element-19">
          <div className="mb-4" data-id="element-20">
            <span className="text-xs font-semibold uppercase tracking-[0.25em] text-electric" data-id="element-21">
              {t('about.label')}
            </span>
          </div>
          <h2 className="text-3xl sm:text-4xl font-extrabold uppercase tracking-tight text-white mb-12" data-id="element-22">
            {t('about.heading')}
          </h2>
        </ScrollFadeIn>

        <div className="grid lg:grid-cols-2 gap-12 lg:gap-16" data-id="element-23">
          <div data-id="element-24">
            <ScrollFadeIn delay={100} data-id="element-25">
              <p className="text-slate-400 leading-relaxed mb-6" data-id="element-26">
                {t('about.p1')}
              </p>
            </ScrollFadeIn>
            <ScrollFadeIn delay={200} data-id="element-27">
              <p className="text-slate-400 leading-relaxed" data-id="element-28">{t('about.p2')}</p>
            </ScrollFadeIn>
          </div>

          <div className="grid sm:grid-cols-2 gap-4" data-id="element-29">
            {highlights.map((item, i) => <ScrollFadeIn key={item.titleKey} delay={(i + 1) * 100} data-id="element-30">
                <div className="p-5 bg-navy border border-slate-700/50 rounded h-full" data-id="element-31">
                  <item.Icon className="w-6 h-6 text-electric mb-3" data-id="element-32" />
                  <h3 className="text-sm font-bold uppercase tracking-wider text-white mb-2" data-id="element-33">
                    {t(item.titleKey)}
                  </h3>
                  <p className="text-xs text-slate-500 leading-relaxed" data-id="element-34">
                    {t(item.descKey)}
                  </p>
                </div>
              </ScrollFadeIn>)}
          </div>
        </div>
      </div>
    </section>;
}